import React from 'react'
import styles from '../../styles.module.css'
import { fmt } from '../metrics'


export const MONITORING_COLUMNS = [
  { key: 'monitoringDate',      label: 'Дата проведения мониторинга' },
  { key: 'subject',             label: 'Предмет' },
  { key: 'totalCount',          label: 'Количество обучающихся, привлекаемых к мониторингу' },
  { key: 'absentCount',         label: 'Отсутствовало на диагностике' },
  { key: 'excellentCount',      label: 'Получили оценку отлично' },
  { key: 'goodCount',           label: 'Получили оценку хорошо' },
  { key: 'satisfactoryCount',   label: 'Получили оценку удовлетворительно' },
  { key: 'unsatisfactoryCount', label: 'Получили оценку неудовлетворительно' },
]

export const groupMonitoringByOrg = (rows) => {
  const result = {}
  for (const r of rows || []) {
    const id = r.organizationId
    if (!result[id]) result[id] = []
    result[id].push(r)
  }
  return result
}


const MonitoringTable = ({ events, organizationName, academicYear }) => {
  const yearTitle = academicYear || '—'

  return (
    <table className={styles.mainTable}>
      <thead>
        <tr className={styles.titleRow}>
          <th colSpan={MONITORING_COLUMNS.length - 1} className={styles.titleLeft}>
            {`Сведения о результатах мониторинга (независимой предметной и метапредметной диагностики) в ${yearTitle} учебном году в ${organizationName || ''}`}
          </th>
          <th colSpan={2} className={styles.titleRight}>
            Форма №2/СВУ
            <div>Таблица №2</div>
          </th>
        </tr>
        <tr>
          <th>№ п/п</th>
          {MONITORING_COLUMNS.map(c => (
            <th key={c.key}>{c.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {events.map((e, idx) => (
          <tr key={idx}>
            <td className={styles.valueCell}>{idx + 1}</td>
            {MONITORING_COLUMNS.map(c => (
              <td key={c.key} className={c.key === 'subject' ? undefined : styles.valueCell}>
                {fmt(e[c.key])}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default MonitoringTable
